// extracted by mini-css-extract-plugin
module.exports = {"pageName":"Report_pageName__jplg9"};